(function(){

    angular.module('tmx-app').controller('areaLevelReportCtrl', ['$scope','$state','$mdDialog', 'tmxUtility','$mdSidenav',
        'TmxDialogService','ServerExceptionService','resolvedData',AreaLevelReportCtrl]);

    function AreaLevelReportCtrl($scope, $state,$mdDialog,tmxUtility,$mdSidenav, TmxDialogService,ServerExceptionService,resolvedData){
        var areaLevelReportVM=this;
        areaLevelReportVM.loading=false;
        areaLevelReportVM.TimeFrames = resolvedData.TimeFrames.data;
    }

})();